import React from 'react';
import Header from './Header';
import AboutUs from './AboutUs';
import Solutions from './Solutions';
import News from './News';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <Header />
      <AboutUs />
      <Solutions />
      <News />
      <Footer />
    </>
  );
};

export default Home;
